import { tracking } from '@bark/bark-core';
import { showQuickFilters, updateQuickFiltersRct } from './dashboard_quick_filters';

export function DashboardFilters() {
	const Bark = (window.Bark = window.Bark || {});
	const seller = (Bark.seller = Bark.seller || {});

	seller.dataFiltered = false;
	seller.responseFilters = [];
	seller.checkedFiltersOnModalOpen = [];
	seller.indeterminateFiltersOnModalOpen = [];
	seller.filtersAreDirty = false;
	seller.unfilteredTotal = 0;
	seller.quickFiltersApplied = [];

	const formatNumber = (seller.formatNumber = (number) => {
		const intl = new Intl.NumberFormat(Bark.ENV.locale || 'GB');
		return intl.format(number);
	});

	seller.delayFetch = function (updateLeadsView) {
		Bark.seller.showFilterLoader();

		if (typeof Bark.seller.fetchTimeout !== 'undefined') {
			window.clearTimeout(Bark.seller.fetchTimeout);
		}

		if (updateLeadsView) {
			$('.seller-dash-v2 .dashboard-projects #sticky-project').empty();
			$('.seller-dash-v2 .dashboard-projects .items').empty();
			$('.seller-dash-v2 .dashboard-project-details').hide();
			Bark.seller.hideNoResultsPanel();
			Bark.seller.showListLoader(true);
		}

		Bark.seller.fetchTimeout = window.setTimeout(function () {
			if (updateLeadsView) {
				Bark.seller.fetchRecords(true);
			} else {
				Bark.seller.fetchFilteredRecords();
			}
		}, 500);
	};

	seller.updateCountForDropdown = function (dropdown) {
		var filterCount = dropdown.find('input:checked').length;

		if (filterCount > 0) {
			dropdown.find('.select-all').addClass('d-none');
			dropdown.find('.clear-filters').removeClass('d-none');
		} else {
			dropdown.find('.clear-filters').addClass('d-none');
			dropdown.find('.select-all').removeClass('d-none');
		}

		dropdown.find('span.filter-count').text(filterCount);
	};

	seller.clearFilters = function () {
		$('.sidebar-content-wrapper .checkbox').prop('indeterminate', false);
		var radioLists = $('.input-list.radio-list');

		//Select the default radio button from the list
		radioLists.each(function (index, list) {
			$(list).find('input').first().prop('checked', true);
		});

		$('input.filter-checkbox').prop({ checked: false });

		$('.clear-input').addClass('d-none');
		$('#keyword-search').val('');

		Bark.seller.delayFetch(false);
	};

	seller.processClearFilters = function (override) {
		Bark.seller.clearFilters();
		Bark.seller.setFiltersDirty();

		Bark.seller.updateAccordianHeaderCounts();

		if (override) {
			Bark.seller.dataFiltered = false;
			Bark.seller.delayFetch(true);
		}
	};

	seller.showFilterPanel = function () {
		$('#dashboard-sidebar-modal').modal('show');

		Bark.seller.checkedFiltersOnModalOpen = $('.sidebar-content-wrapper input:checked');
		Bark.seller.indeterminateFiltersOnModalOpen = $(
			'.sidebar-content-wrapper input:indeterminate',
		);
		Bark.seller.searchTermOnModalOpen = $('#keyword-search').val();

		Bark.seller.checkedFiltersOnModalOpen.each(function (index, input) {
			if (!$(input).hasClass('default-button')) {
				$(input).closest('.collapse').collapse('show');
			}
		});

		Bark.seller.fetchFilteredRecords();

		if (Bark.seller.dataFiltered) {
			$('.clear-all-filters').removeClass('d-none');
		}
	};

	seller.hideFilterPanelAndResetValues = function () {
		$('#dashboard-sidebar-modal').modal('hide');

		//They have not clicked apply so we need to reset the modal to the values that it had when first opened.
		$('.sidebar-content-wrapper input')
			.prop('checked', false)
			.prop('indeterminate', false);

		if (Bark.seller.checkedFiltersOnModalOpen.length > 0) {
			Bark.seller.checkedFiltersOnModalOpen.each(function (index, input) {
				$(input).prop('checked', true);
			});
		}

		if (Bark.seller.indeterminateFiltersOnModalOpen.length > 0) {
			Bark.seller.indeterminateFiltersOnModalOpen.each(function (index, input) {
				$(input).prop('indeterminate', true);
			});
		}

		$('#keyword-search').val(Bark.seller.searchTermOnModalOpen);

		Bark.seller.updateAccordianHeaderCounts();
		if (showQuickFilters()) {
			updateQuickFiltersRct();
		}
		Bark.seller.stripCounts();

		// Bark.seller.hideApplyFiltersPanel();
	};

	seller.setFiltersDirty = function () {
		Bark.seller.filtersAreDirty =
			$('.sidebar-content-wrapper input:not(.default-button):checked').length > 0 ||
			$('#keyword-search').val() !== '';
	};

	seller.renderFilters = function (filters) {
		if (!filters?.length) {
			return false;
		}

		Bark.seller.responseFilters = [];

		filters.forEach(function (filter) {
			if (filter.type === 'header') {
				var accordionId = 'accordion-' + filter.id;

				if ($('#' + accordionId).length) {
					Bark.seller.updateCountsForAccordion(filter, accordionId);
				} else {
					Bark.seller.createAccordionAndAppend(filter, accordionId);
				}
			} else if (filter.type === 'header_radio') {
				var accordionId = 'accordion-' + filter.id;

				if ($('#' + accordionId).length) {
					Bark.seller.updateCountsForHeaderRadio(filter, accordionId);
				} else {
					Bark.seller.createRadioAccordionAndAppend(filter, accordionId);
				}
			} else if (filter.type === 'select') {
				if (!$('select#filter-input-' + filter.id).length > 0) {
					var select = $('#select-template').clone();
					var filterKey = '';

					select.find('select').attr('id', `filter-input-${filter.id}`);
					select
						.find('label')
						.attr('for', `filter-input-${filter.id}`)
						.text(filter.title);

					if (filter.options.length > 0) {
						filter.options.forEach(function (option) {
							select
								.find('select')
								.append(
									'<option value="' +
										option.filter_value +
										'">' +
										option.title +
										'</option>',
								);

							filterKey = option.filter_key;
						});
					}

					select.attr('data-filter-key', filterKey);

					select.find('select').select2({
						theme: 'bark-leads',
						minimumResultsForSearch: -1,
						debug: true,
					});

					select.removeClass('d-none');
					$('.accordion-list').append(select);
				}
			}
		});

		if (Bark.ProjectsData.show_unread) {
			var unreadCheckbox = $('#viewed_unread_checkbox');

			if (unreadCheckbox.length > 0) {
				unreadCheckbox.prop('checked', true);

				unreadCheckbox.closest('.collapse').collapse('show');
			}

			Bark.ProjectsData.show_unread = false;
		}

		Bark.seller.setUnreadCount();
		Bark.seller.apply_prefilters();

		if (showQuickFilters()) {
			updateQuickFiltersRct();
		}
	};

	seller.setUnreadCount = function () {
		Bark.seller.unreadCount =
			$('#viewed_unread_checkbox').closest('.custom-control').data('count') || 0;
	};

	seller.selectAll = function (dropdown) {
		var checkboxes = dropdown.find('.checkbox');

		checkboxes.each(function (index, box) {
			$(box).prop('checked', true);
		});

		Bark.seller.updateCountForDropdown(dropdown);
		Bark.seller.delayFetch(false);
	};

	seller.selectAllRadioChildren = function (input) {
		var allCheckboxInputs = input.closest('.input-list').find('input:checkbox');
		var childInputs = input
			.closest('.grouped-radio')
			.find('.child-checkboxes')
			.find('input');

		allCheckboxInputs.each(function (index, input) {
			$(input).prop('checked', false);
		});

		input.prop('checked', true);

		childInputs.each(function (index, input) {
			$(input).prop('checked', true);
		});
	};

	seller.selectAllChildren = function (input) {
		var inputs = input.closest('.checkbox-list').find('.child-checkboxes').find('input');
		let setAsIntermediate = false;

		if (input.is(':checked')) {
			inputs.each(function (index, input) {
				const element = $(input);

				if (element.is(':disabled')) {
					setAsIntermediate = true;
				} else {
					element.prop('checked', true);
				}
			});
		} else {
			inputs.each(function (index, input) {
				$(input).prop('checked', false);
			});
		}

		input.prop('indeterminate', setAsIntermediate);
	};

	seller.updateCountsForHeaderRadio = function (groupedFilterData) {
		if (groupedFilterData.children.length > 0) {
			groupedFilterData.children.forEach(function (filter) {
				if (filter.type === 'grouped_radio') {
					$('#filter-input-' + filter.id)
						.closest('.custom-control')
						.find('.custom-control-label span')
						.text(' (' + formatNumber(filter.count) + ')');
					if (filter.count === 0) {
						$('#filter-input-' + filter.id)
							.closest('.custom-control-input')
							.prop('disabled', true);
					} else {
						$('#filter-input-' + filter.id)
							.closest('.custom-control-input')
							.prop('disabled', false);
					}
					if (filter.children.length > 0) {
						filter.children.forEach(function (groupedRadioChild) {
							$('#' + groupedRadioChild.id)
								.closest('.custom-control')
								.find('.custom-control-label span')
								.text(' (' + formatNumber(groupedRadioChild.count) + ')');
							if (groupedRadioChild.count === 0) {
								$('#' + groupedRadioChild.id)
									.closest('.custom-control-input')
									.prop('disabled', true);
							} else {
								$('#' + groupedRadioChild.id)
									.closest('.custom-control-input')
									.prop('disabled', false);
							}
							Bark.seller.responseFilters.push(groupedRadioChild.id);
						});
					}
				} else {
					$('#filter-input-' + filter.id)
						.closest('.custom-control')
						.find('.custom-control-label span')
						.text(' (' + formatNumber(filter.count) + ')');
					if (filter.count === 0) {
						$('#filter-input-' + filter.id)
							.closest('.custom-control-input')
							.prop('disabled', true);
					} else {
						$('#filter-input-' + filter.id)
							.closest('.custom-control-input')
							.prop('disabled', false);
					}
					Bark.seller.responseFilters.push(filter.id);
				}
			});
		}
	};

	seller.updateCountsForAccordion = function (filterData, accordionId) {
		var existingFilters = $('#' + accordionId)
			.find('.custom-control-input')
			.map(function () {
				return $(this).prop('id').replace('filter-input-', '');
			})
			.toArray();

		if (filterData.children.children) {
			if (filterData.children.count !== null) {
				$('#filter-input-' + filterData.children.id)
					.closest('.custom-control')
					.find('.custom-control-label span')
					.text(' (' + formatNumber(filterData.children.count) + ')');
				$('#filter-input-' + filterData.children.id)
					.closest('.custom-control')
					.data('count', filterData.children.count);
			}

			if (filterData.children.count === 0) {
				$('#filter-input-' + filterData.children.id)
					.closest('.custom-control-input')
					.prop('disabled', true);
			} else {
				$('#filter-input-' + filterData.children.id)
					.closest('.custom-control-input')
					.prop('disabled', false);
			}
			Bark.seller.responseFilters.push(filterData.children.id);

			Bark.seller.updateFilterCountsFromResponse(filterData.children.children);
		} else {
			Bark.seller.updateFilterCountsFromResponse(filterData.children);

			var responseFilters = filterData.children.map(function (el) {
				return el.id.replace('filter-input-', '');
			});

			var zeroCountFilters = existingFilters.filter(function (el) {
				return responseFilters.indexOf(el) < 0;
			});

			Bark.seller.makeZeroAndDisabled(zeroCountFilters);
		}
	};

	seller.updateFilterCountsFromResponse = function (filters) {
		filters.forEach(function (filter) {
			var responseFilter = $('#filter-input-' + filter.id);
			if (filter.count !== null) {
				responseFilter
					.closest('.custom-control')
					.find('.custom-control-label span')
					.text(' (' + formatNumber(filter.count) + ')');
				responseFilter.closest('.custom-control').data('count', filter.count);
			}

			if (filter.count === 0) {
				if (!responseFilter.prop('checked')) {
					responseFilter.closest('.custom-control-input').prop('disabled', true);
				}
			} else {
				responseFilter.closest('.custom-control-input').prop('disabled', false);
			}
		});
	};

	seller.makeZeroAndDisabled = function (zeroCountFilterIds) {
		zeroCountFilterIds.forEach(function (zeroCountFilterId) {
			var filter = $('#' + zeroCountFilterId);

			filter.closest('.custom-control').find('.custom-control-label span').text(' (0)');
			filter.closest('.custom-control').data('count', filter.count);

			if (!filter.prop('checked')) {
				$(filter).prop('disabled', true);
			}
		});
	};

	seller.createRadioAccordionAndAppend = function (filterData, accordionId) {
		var accordion = $('#accordion-template-radios').clone();
		var accordionBody = accordion.find('.filter-collapse-body');
		accordionBody.find('.input-list').addClass('radio-list');

		accordion = Bark.seller.fillAccordionData(accordion, filterData, accordionId);

		if (filterData.children) {
			filterData.children.forEach(function (filter) {
				if (filter.type === 'radio') {
					accordionBody
						.find('.input-list')
						.append(
							Bark.seller.buildRadioButtonHtml(
								filter.id,
								filter.filter_key,
								filter.filter_value,
								filter.title,
								filter.count,
								filter.default_selected,
							),
						);
				} else if (filter.type === 'checkbox') {
					accordionBody
						.find('.input-list')
						.append(
							Bark.seller.buildCheckbox(
								filter.id,
								filter.filter_key,
								filter.filter_value,
								filter.title,
								filter.count,
							),
						);
				} else if (filter.type === 'grouped_radio') {
					accordionBody.find('.input-list').append(Bark.seller.buildGroupedRadio(filter));
				}

				Bark.seller.responseFilters.push(filter.id);
			});
		}

		accordion.removeClass('d-none');

		$('.accordion-list').append(accordion);
	};

	seller.buildGroupedRadio = function (filter) {
		var groupedRadioHtml;
		var checkboxHtml = [];
		const groupedRadio = $('<div class="grouped-radio">');
		const childCheckboxes = $('<div class="child-checkboxes pl-two">');

		groupedRadioHtml = Bark.seller.buildRadioButtonHtml(
			filter.id,
			filter.filter_key,
			filter.filter_value,
			filter.title,
			filter.count,
			filter.default_selected,
			'override',
		);

		filter.children.forEach(function (child) {
			checkboxHtml.push(
				Bark.seller.buildCheckbox(
					child.id,
					child.filter_key,
					child.filter_value,
					child.title,
					child.count,
				),
			);

			Bark.seller.responseFilters.push(child.id);
		});

		childCheckboxes.append(checkboxHtml);
		groupedRadio.append(childCheckboxes);

		return groupedRadio;
	};

	seller.trackAccordionHeaderClick = (accordionHeaderElement, filterData) => {
		accordionHeaderElement.off('click.filterTracking').on('click.filterTracking', () => {
			tracking(
				'seller-leads-dashboard-&-responses',
				`${
					accordionHeaderElement.hasClass('collapsed') ? 'Open' : 'Close'
				} filter accordion`,
				{
					filter_id: filterData.id,
					filter_title: filterData.title,
				},
			);
		});
	};

	seller.fillAccordionData = function (accordion, filterData, accordionId) {
		var accordionHeader = accordion.find('.filter-header');
		var accordionBody = accordion.find('.filter-collapse-body');

		seller.trackAccordionHeaderClick(accordionHeader, filterData);

		accordion.find('.filter-title span.label').text(filterData.title);

		accordion.attr('id', accordionId);
		accordionHeader.attr('id', 'heading-' + filterData.id);
		accordionHeader.attr('aria-controls', 'collapse-' + filterData.id);
		accordionHeader.attr('data-target', '#collapse-' + filterData.id);
		accordionBody.attr('data-parent', '#' + accordionId);
		accordionBody.attr('aria-labelledby', 'heading-' + filterData.id);
		accordionBody.attr('id', 'collapse-' + filterData.id);

		return accordion;
	};

	seller.createAccordionAndAppend = function (filterData, accordionId) {
		var accordion = $('#accordion-template').clone();
		var accordionHeader = accordion.find('.filter-header');
		var accordionBody = accordion.find('.filter-collapse-body');

		accordion.find('.filter-title span.label').text(filterData.title);

		accordion.attr('id', accordionId);
		accordionHeader.attr('id', 'heading-' + filterData.id);
		accordionHeader.attr('aria-controls', 'collapse-' + filterData.id);
		accordionHeader.attr('data-target', '#collapse-' + filterData.id);
		accordionBody.attr('data-parent', '#' + accordionId);
		accordionBody.attr('aria-labelledby', 'heading-' + filterData.id);
		accordionBody.attr('id', 'collapse-' + filterData.id);

		seller.trackAccordionHeaderClick(accordionHeader, filterData);

		if (filterData.children.children) {
			accordionBody
				.find('.big-daddy-checkbox')
				.prepend(
					Bark.seller.buildCheckbox(
						filterData.children.id,
						filterData.children.filter_key,
						filterData.children.filter_value,
						filterData.children.title,
						filterData.children.count,
						filterData.children.default_selected,
						'override',
					),
				);

			Bark.seller.responseFilters.push(filterData.children.id);

			filterData.children.children.forEach(function (filter) {
				accordionBody
					.find('.child-checkboxes')
					.append(
						Bark.seller.buildCheckbox(
							filter.id,
							filter.filter_key,
							filter.filter_value,
							filter.title,
							filter.count,
							filter.default_selected,
						),
					);

				Bark.seller.responseFilters.push(filter.id);
			});
		} else {
			filterData.children.forEach(function (filter) {
				accordionBody
					.find('.checkbox-list')
					.append(
						Bark.seller.buildCheckbox(
							filter.id,
							filter.filter_key,
							filter.filter_value,
							filter.title,
							filter.count,
							filter.default_selected,
						),
					);

				Bark.seller.responseFilters.push(filter.id);
			});
		}

		accordion.removeClass('d-none');

		$('.accordion-list').append(accordion);
	};

	seller.buildCheckbox = function (
		id,
		dataKey,
		dataValue,
		title,
		count,
		defaultSelected,
		additionalClasses,
	) {
		var countHtml =
			count !== null ? '<span class="text-xs count ml-1"> (' + count + ')</span>' : '';
		var additionalClassesString = additionalClasses ? additionalClasses : '';
		var disabled = count === 0 ? ' disabled="disabled"' : '';
		var selected =
			typeof defaultSelected !== 'undefined' && defaultSelected === true
				? ' checked="checked"'
				: '';
		const label = $(
			`<label class="custom-control custom-checkbox" data-count="${count}">`,
		);
		const checkBoxId = `filter-input-${id}`;

		const inner =
			'<input class="checkbox custom-control-input filter-checkbox ' +
			additionalClassesString +
			'" type="checkbox" id="' +
			checkBoxId +
			'" data-filter-key="' +
			dataKey +
			'" data-filter-value="' +
			dataValue +
			'"' +
			disabled +
			selected +
			'>' +
			'<span class="custom-control-label" for="' +
			checkBoxId +
			'">' +
			title +
			countHtml +
			'</span>';

		label.html(inner);

		$('input', label)
			.off('change.filterTracking')
			.on('change.filterTracking', ({ currentTarget }) => {
				tracking(
					'seller-leads-dashboard-&-responses',
					`${currentTarget.checked ? 'Select' : 'Deselect'} filter option`,
					{
						filter_id: id,
						filter_title: title,
					},
				);
			});

		return label;
	};

	seller.buildRadioButtonHtml = function (
		id,
		dataKey,
		dataValue,
		title,
		count,
		defaultSelected,
		additionalClasses,
	) {
		var countHtml =
			count !== null ? '<span class="text-xs count ml-1"> (' + count + ')</span>' : '';
		var additionalClassesString = additionalClasses ? additionalClasses : '';
		var disabled = count === 0 ? ' disabled="disabled"' : '';
		var selected =
			typeof defaultSelected !== 'undefined' && defaultSelected === true
				? ' checked="checked"'
				: '';
		var defaultButton = selected ? ' default-button ' : '';
		const label = $('<label>').addClass('custom-control custom-radio');
		const elemId = `filter-input-${id}`;

		const inner =
			'<input class="checkbox custom-control-input ' +
			defaultButton +
			additionalClassesString +
			'" name="' +
			dataKey +
			'response-radio"  type="radio" id="' +
			elemId +
			'" data-filter-key="' +
			dataKey +
			'" data-filter-value="' +
			dataValue +
			'"' +
			disabled +
			selected +
			'>' +
			'<span class="custom-control-label" for="' +
			elemId +
			'">' +
			title +
			countHtml +
			'</span>';

		label.html(inner);

		$('input', label)
			.off('change.filterTracking')
			.on('change.filterTracking', ({ currentTarget }) => {
				tracking(
					'seller-leads-dashboard-&-responses',
					`${currentTarget.checked ? 'Select' : 'Deselect'} filter option`,
					{
						filter_id: id,
						filter_title: title,
					},
				);
			});

		return label;
	};

	seller.stripCounts = function () {
		$('.custom-control .count').text('');
	};

	seller.buildFilterQueryString = function () {
		var sideBar = $('.sidebar-content-wrapper');
		var allCheckedInputs = sideBar.find('input:checked');

		var payload = {
			show_filter_counts: true,
			search: Bark.seller.getKeywordFilterValue() || undefined,
			next_page: Bark.seller.nextPage || undefined,
		};

		if (allCheckedInputs.length > 0) {
			allCheckedInputs.each(function (index, input) {
				var self = $(input);
				var key = self.attr('data-filter-key');

				if (typeof payload[key] === 'undefined') {
					payload[key] = [];
				}

				// If the big override checkbox is clicked we don't want to send all the individual child filters as well
				if (
					self.closest('.checkbox-list').find('.big-daddy-checkbox input:checked')
						.length === 0 ||
					self.hasClass('override')
				) {
					if (!self.prop('indeterminate') && !self.hasClass('js-omit-from-filters')) {
						payload[key].push(self.attr('data-filter-value'));
					}
				}
			});
		}

		return payload;
	};

	seller.getKeywordFilterValue = function () {
		return $('#keyword-search').val()
			? encodeURIComponent($('.dashboard-projects-filters .field-keyword').val())
					.toLowerCase()
					.replace(/%20/g, '+')
			: '';
	};

	seller.apply_prefilters = function () {
		if (apply_filters) {
			try {
				var hasFilters = false;
				// can add additional cases in here if we want more prefilters
				if (apply_filters.hasOwnProperty('cats')) {
					// Clear filters, then select this category
					$('.sidebar-content-wrapper input')
						.prop('checked', false)
						.prop('indeterminate', false);
					$('#keyword-search').val(null);
					Bark.seller.stripCounts();
					apply_filters.cats.forEach(function (item, index) {
						if (!Number.isInteger(item)) {
							return;
						}
						var cbox = $('#category_id_' + item + '_checkbox');
						if (cbox && !cbox.prop('disabled')) {
							cbox.prop('checked', true);
							hasFilters = true;
						}
					});
				}

				if (!hasFilters) {
					return;
				}
				// Hide the success message
				$('.js-respond-message-success-message').hide();

				// Update the filtered results
				Bark.seller.setFiltersDirty();
				Bark.seller.dataFiltered = Bark.seller.filtersAreDirty;
				Bark.seller.fetchRecords(true, true);

				// On mobile, close the project so that the user sees the list
				Bark.seller.hideProject();

				if (Bark.seller.isMobile) {
					// Set the URL hash, which will allow the user to go back to the lead if they click the back button
					Bark.setPageState({ projectId: 0 }, null, true);
				}
				// delete the prefilters so it doesnt happen again on this pageload
				apply_filters = false;
			} catch (e) {
				bugsnagClient.notify(e);
			}
		}
	};

	seller.sendFilterHeapEvents = (filters) => {
		let reducedFilters = Object.keys(filters).reduce(
			(appliedFilters, currentFilterKey) => {
				if (
					currentFilterKey !== 'show_filter_counts' &&
					currentFilterKey !== 'next_page' &&
					filters[currentFilterKey]
				) {
					appliedFilters.filter_names.push(currentFilterKey);
					appliedFilters.filter_values.push(
						`${currentFilterKey}: ${filters[currentFilterKey]}`,
					);
				}
				return appliedFilters;
			},
			{ filter_names: [], filter_values: [] },
		);
		tracking('seller-leads-dashboard-&-responses', 'Filters - apply', {
			filter_names: reducedFilters.filter_names.toString(),
			filter_values: reducedFilters.filter_values.toString(),
		});
	};

	seller.getAppliedFiltersTotal = () => {
		let filtersApplied = $(
			'.sidebar-content-wrapper input:not(.default-button):checked',
		).length;
		if ($('#keyword-search').val() !== '') {
			filtersApplied++;
		}
		return filtersApplied ?? 0;
	};
}
